import { useEffect } from "react";
import { useAuthContext } from "@/features/auth/hooks/use-auth-context";
import { SplashScreen } from "expo-router";
import { authTrace } from "@/features/auth/lib/auth-trace";

SplashScreen.preventAutoHideAsync();

export function SplashScreenController({
  isAssetsLoaded,
}: {
  isAssetsLoaded: boolean;
}) {
  const { isLoading } = useAuthContext();

  useEffect(() => {
    if (!isLoading && isAssetsLoaded) {
      SplashScreen.hideAsync();
      authTrace.splashHidden();
    }
  }, [isLoading, isAssetsLoaded]);

  return null;
}
